export default __webpack_public_path__ + "static/media/FG_19.d930a5be.JPG";